export default __webpack_public_path__ + "static/media/grafema_SET_12.3010e1da.jpeg";